function attachEventListeners() {
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"][data-dispatch-type="custom-card"]');
    addToCartForms.forEach((form) => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const addButton = form.querySelector('span[data-button-name="add"]');
            const loadingButton = form.querySelector('span[data-button-name="loading"]');
            addButton.classList.add('hidden');
            loadingButton.classList.remove('hidden');
            addButton.classList.remove('flex');
            loadingButton.classList.add('flex');
            try {
                const cartAddResponse = await fetch('/cart/add', {
                    method: 'POST',
                    body: new FormData(form),
                });
                if (!cartAddResponse.ok) {
                    throw new Error('Failed to add to cart');
                }
                const cartRes = await fetch('/cart.js');
                const cartData = await cartRes.json();
                document.querySelectorAll('.cart-count').forEach((el) => {
                    el.textContent = cartData.item_count;
                });
                window.dispatchEvent(new CustomEvent('custom-update-cart'));
                window.dispatchEvent(new CustomEvent('open-cart-drawer'));
            } catch (error) {
                console.error('Error adding to cart:', error);
            } finally {
                addButton.classList.remove('hidden');
                loadingButton.classList.add('hidden');
                addButton.classList.add('flex');
                loadingButton.classList.remove('flex');
            }
        })
    })
}
window.addEventListener('attach-add-to-cart-listener', attachEventListeners);